var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[(_vm.newsType === 'CUSTOM')?_c('span',[_vm._v("-")]):(_vm.value)?_c('span',[_vm._v(_vm._s(_vm.$utils.timeText(_vm.value)))]):_c('span',{staticStyle:{"color":"#ea002c"}},[_vm._v("미확인")])])}
var staticRenderFns = []

export { render, staticRenderFns }